import { useEffect, useRef, useState } from 'react';
import useSWR from 'swr';

import keycloakService from '../../keycloak_service';

const fetchFromSinatra = (queryParams) => {
  const [sinatraEndpoint, fetchOptions] = queryParams;
  const keycloakOrigin = keycloakService.keycloak.authServerUrl;
  return fetch(`${keycloakOrigin}${sinatraEndpoint}`, fetchOptions).then(response => response.json())
}

// This hook augments the passed in comments with their authoring users, fetching those users
// from Keycloak (via the Sinatra app) if necessary.
const useUserSessionData = (userId = null) => {
  const errorTimeoutRef = useRef(null);
  const [errorMessage, setError] = useState(null);

  const keycloakHeader = keycloakService.getAuthHeader();
  const hasKeycloakHeader = keycloakHeader?.length;
  const fetchOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakHeader,
    },
  };

  const realm = keycloakService.keycloak.realm || null;
  const {
    data,
    isLoading,
    error,
    mutate,
  } = useSWR(hasKeycloakHeader ? [`admin/realms/${realm}/users/${userId}/sessions`, fetchOptions] : null, fetchFromSinatra, {
    refreshInterval: 3000,
  })

  useEffect(() => {
    if (error) {
      errorTimeoutRef.current = setTimeout(() => {
        setError(error?.message);
      }, 1500);
    } else {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }

    return () => {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }
  }, [error]);

  return {
    loading: isLoading,
    error: errorMessage,
    data,
    refetch: mutate,
  }
};

export default useUserSessionData;
